import { Icon, Typography } from '@/modules/perseo-billing/ui/react/src';

const LABEL_GIFT_CARD_BALANCE_TITLE = 'Tienes un monto a favor ';
const LABEL_GIFT_CARD_BALANCE_MESSAGE =
  'El monto que no utilices en esta compra quedará guardado en tu Gift Card. Para usarlo, tendrás que ingresar el mismo número y clave.';

export const GiftCardBalanceMessage = () => {
  return (
    <div className="co-flex co-flex-col co-bg-pds-primary-100 co-p-2 co-border-1 co-border-blue-500 co-rounded-md">
      <div className="co-flex co-fill-current co-items-center co-gap-8px">
        <div>
          <Icon
            className="co-fill-current co-text-primary-main"
            icon="InformationIconFilled"
            width={17}
            height={17}
          />
        </div>
        <Typography size="h5" weight="semibold">
          {LABEL_GIFT_CARD_BALANCE_TITLE}
        </Typography>
      </div>
      <Typography leading="normal" size="body2">
        {LABEL_GIFT_CARD_BALANCE_MESSAGE}
      </Typography>
    </div>
  );
};
